function loadResourceFile(filename, filetype){
    if (window.filesadded.indexOf("["+filename+"]") !== -1) return;

    let fileref = document.createElement('script');
    if (filetype == "js"){
        fileref.setAttribute("type","text/javascript");
        fileref.setAttribute("src", filename);
    } else if (filetype=="css"){
        let fileref = document.createElement("link");
        fileref.setAttribute("rel", "stylesheet");
        fileref.setAttribute("type", "text/css");
        fileref.setAttribute("href", filename);
    }

    if (window.filesadded.indexOf("["+filename+"]") == -1){
        document.getElementsByTagName("head")[0].appendChild(fileref);
        window.filesadded += "["+filename+"]";
    } 
}

exports.loadResourceFile = loadResourceFile